import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBan, faCircle, faExclamationTriangle, faStopCircle } from '@fortawesome/free-solid-svg-icons';

import { PaceStatusBadge } from './pace-status-badge.interface';

/**
 * Presentational notification status badge: the escalated / cancelled / unread / paused
 * indicator icons followed by the status label.
 *
 * Each indicator can be switched off individually, for hosts that already show the same
 * information elsewhere (the dashboard card renders escalated and cancelled in its header).
 */
@Component({
    selector: 'pace-status-badge',
    imports: [FontAwesomeModule],
    templateUrl: './pace-status-badge.component.html',
    styleUrls: ['./pace-status-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaceStatusBadgeComponent {
    public readonly badge = input.required<PaceStatusBadge>();
    public readonly showEscalatedIcon = input(true);
    public readonly showCancelledIcon = input(true);
    public readonly showUnreadIcon = input(true);

    public readonly faExclamationTriangle = faExclamationTriangle;
    public readonly faBan = faBan;
    public readonly faCircle = faCircle;
    public readonly faStopCircle = faStopCircle;
}
